<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="para"><a id="page_i"></a>Ian Bradley is Emeritus Professor of Cultural and Spiritual History at the University of St Andrews. Among his many books are <em>Pilgrimage: A Cultural and Spiritual Journey</em> (2009), <em>Argyll: The Making of a Spiritual Landscape</em> (St Andrew Press, 2015), <em>Following the Celtic Way</em> (Darton, Longman &amp; Todd, 2018) and <em>The Fife Pilgrim Way</em> (Birlinn, 2019).</p>
<p class="indent-para"><em>The Coffin Roads: Journeys to the West</em> is the second in a trilogy of books on aspects of death and the afterlife. The first, <em>The Quiet Haven: An Anthology of Readings on Death and Heaven</em>, was published in 2021 by Darton, Longman &amp; Todd and the third, <em>Breathers of an Ampler Air: Heaven and the Victorians</em>, is due to be published by the Sacristy Press in 2024.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?5d4d9eba